import { EnrollmentStatus, type NupStatusResponse } from '@ark/nup-shared';
import { getCopy } from '../constants/copy';

export const ENROLL_BLOCK_TOAST = {
  udpMiss: '暫不符合參加條件',
  enrollEnded: '報名已截止',
} as const;

/** 已登录但当前不能报名时返回提示文案；可报名返回 null。 */
export function getEnrollBlockToast(
  latest: Pick<NupStatusResponse, 'canEnroll' | 'eligible'>,
  isEn = false,
): string | null {
  if (latest.canEnroll) {
    return null;
  }
  const copy = getCopy(isEn);
  return latest.eligible ? copy.enrollEnded : copy.udpMiss;
}

/** 仅未报名或无入金可再报（status=3）时展示报名按钮。 */
export function shouldShowEnrollBtn(
  loading: boolean,
  statusLoaded: boolean,
  enrollmentStatus: EnrollmentStatus | null,
): boolean {
  if (loading || !statusLoaded) {
    return false;
  }
  if (enrollmentStatus == null) {
    return true;
  }
  return enrollmentStatus === EnrollmentStatus.RE_ENROLLABLE;
}
